<div *ngIf="params && params.value"
     class="comments-trigger-container">
    <span class="ellipsis-icon"
          (click)="showCommentsModal($event)"></span>
</div>